import { Button, Container, CreateTableState, Icon, List, Spinner } from 'gu-ui-kit'
import isEqual from 'lodash/isEqual'
import omit from 'lodash/omit'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'modules/Statistics/subcomponents/Layout/Table/statistics-table.module.scss'
import GridSpinner from 'components/UI/GridSpinner'
import EmptyResults from 'components/EmptyResults'
import { ReactComponent as EmptyStatistics } from 'images/illustration/empty-statistics.svg'

const LIMIT = 50

const TableComponent = ({
  table,
  tableConfig,
  filters,
  dropTableData = () => {},
  groupBy,
  onTableParamsUpdate = () => {},
  isDemoMode,
}) => {
  const { t } = useTranslation(['statistics'])
  const [page, setPage] = useState(1)
  const [filtersState, setFiltersState] = useState(
    omit(filters, ['include_vat', 'date_group_period']),
  )

  useEffect(() => {
    dropTableData()
    setPage(1)
  }, [filtersState, groupBy, isDemoMode])

  useEffect(() => {
    onTableParamsUpdate({
      group_by: groupBy,
      limit: LIMIT,
      offset: (page - 1) * LIMIT,
    })
  }, [page, isDemoMode, groupBy, filtersState])

  useEffect(() => {
    const omittedFilters = omit(filters, ['include_vat', 'date_group_period'])
    !isEqual(filtersState, omittedFilters) && setFiltersState(omittedFilters)
  }, [filters])

  const changePage = useCallback((val) => setPage(page + val), [page])

  const tableState = CreateTableState(tableConfig, table.data)

  return !table.loading && table.data.length === 0 ? (
    <EmptyResults image={<EmptyStatistics />} />
  ) : (
    <>
      <div className={styles['table-container']}>
        <List
          Loader={() => <GridSpinner />}
          loading={table.loading}
          table={tableState}
          config={tableConfig}
        />
      </div>

      {table.data?.length > 0 && (
        <div className={styles['pagination']}>
          <Container
            display={'flex'}
            flexAlign={'center'}
            flexJustify={'center'}
            className={styles['show-more__container']}
          >
            {table.pagination.total > table.data.length && (
              <Button
                onClick={() => changePage(1)}
                className={styles['show-more__button']}
                variant={'link'}
                color={'Label-GU-Primary'}
                startIcon={
                  table.loading ? (
                    <Spinner
                      width={16}
                      color={'inherit'}
                    />
                  ) : null
                }
                endIcon={
                  <Icon
                    name={'arrow1-down'}
                    color={'inherit'}
                    size={'s'}
                  />
                }
              >
                {t('common::pagination.show_more')}
              </Button>
            )}
          </Container>
        </div>
      )}
    </>
  )
}

TableComponent.propTypes = {
  table: PropTypes.shape({
    loading: PropTypes.bool,
    data: PropTypes.array,
    summary: PropTypes.object,
    pagination: PropTypes.object,
  }),
  pagination: PropTypes.object,
  loading: PropTypes.bool,
  filters: PropTypes.object,
  dropTableData: PropTypes.func,
  onTableParamsUpdate: PropTypes.func,
  groupBy: PropTypes.string,
  columns: PropTypes.array,
  isDemoMode: PropTypes.bool,
  tableState: PropTypes.object,
  tableConfig: PropTypes.object,
}

export default TableComponent
